import { render, staticRenderFns } from "./statisticsList.vue?vue&type=template&id=4de393aa&scoped=true&"
import script from "./statisticsList.vue?vue&type=script&lang=js&"
export * from "./statisticsList.vue?vue&type=script&lang=js&"
import style0 from "./statisticsList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./statisticsList.vue?vue&type=style&index=1&id=4de393aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de393aa",
  null
  
)

export default component.exports